@if (loading()) {
  <nb-card>
    <nb-card-body class="state-row">
      <nb-spinner status="primary"></nb-spinner>
      <span>Untermieter werden geladen…</span>
    </nb-card-body>
  </nb-card>
} @else if (loadError()) {
  <nb-card status="danger">
    <nb-card-body class="state-row">
      <span>Fehler beim Laden der Untermieter.</span>
      <button nbButton ghost size="small" (click)="retry()">Erneut versuchen</button>
    </nb-card-body>
  </nb-card>
} @else if (sections().length === 0) {
  <nb-card>
    <nb-card-body class="state-row">
      <span>Lege zuerst einen Gebäudeteil an, um Untermieter zuweisen zu können.</span>
    </nb-card-body>
  </nb-card>
} @else {
  <nb-card>
    <nb-card-header class="toolbar">
      <input
        nbInput
        fieldSize="small"
        type="text"
        class="search-input"
        placeholder="Untermieter oder Adresse suchen…"
        [value]="searchText()"
        (input)="searchText.set($any($event.target).value)" />
      <button
        nbButton
        status="primary"
        size="small"
        (click)="openAssignDialog()">
        Untermieter zuweisen
      </button>
    </nb-card-header>

    <nb-card-body class="groups">
      @if (!hasAnyAssignment()) {
        <div class="empty-state">
          <p>Noch keine Untermieter zugewiesen.</p>
          <button nbButton status="primary" size="small" (click)="openAssignDialog()">
            Ersten Untermieter zuweisen
          </button>
        </div>
      } @else if (!hasSearchHits()) {
        <div class="empty-state">
          <p>Keine Treffer für „{{ searchText() }}".</p>
        </div>
      } @else {
        @for (group of groups(); track group.section.id) {
          @if (group.assignments.length > 0 || !searchText()) {
            <section class="section-group">
              <header class="section-header">
                <div class="section-title">
                  <span>{{ group.label }}</span>
                  <span class="count-pill">{{ group.assignments.length }}</span>
                </div>
                <button
                  nbButton
                  ghost
                  size="small"
                  (click)="openAssignDialog(group.section.id)">
                  Hinzufügen
                </button>
              </header>

              @if (group.assignments.length === 0) {
                <div class="section-empty">Keine Untermieter zugewiesen.</div>
              } @else {
                <ul class="assignment-list">
                  @for (a of group.assignments; track a.id) {
                    <li class="assignment-row">
                      <span
                        class="color-dot"
                        [style.background]="a.tenantColor || '#cbd5e1'"
                        [attr.aria-hidden]="true"></span>
                      <span class="tenant-name">{{ a.tenantName }}</span>
                      <span class="created">zugewiesen am {{ a.created | date: 'dd.MM.yyyy' }}</span>
                      <button
                        nbButton
                        ghost
                        status="danger"
                        size="small"
                        class="row-action"
                        (click)="remove(a)">
                        Entfernen
                      </button>
                    </li>
                  }
                </ul>
              }
            </section>
          }
        }
      }
    </nb-card-body>
  </nb-card>
}
